import '@/js/dist/www.iichi.com/common';

import Vue from 'vue';
import Slider from '@/js/components/common/ui/slider.vue';
import MailMagazine from '@/js/components/www.iichi.com/organisms/mailMagazine.vue';

document.addEventListener('DOMContentLoaded', () => {
  new Vue({
    el: 'slider',
    components: {
      Slider,
    },
  });

  if (document.querySelector('mail-magazine')) {
    new Vue({
      el: 'mail-magazine',
      components: {
        MailMagazine,
      },
    });
  }
});
